<template>
<v-card tile class="grey lighten-4" >
  <v-card-text >
    <v-row >
      <v-col
        v-for='msg in notifications'
        :key='msg.id'
        cols="6" >
        <v-card
          :class="isSelected(msg)"
          height="100%"
          :to="`/settings/me/notifications/${msg.slug}`" >
          <v-card-title >
            {{ msg.title }}
            <v-spacer/>
            <!-- <v-chip >{{ msg. }}</v-chip> -->
          </v-card-title>
          <v-card-text v-text="msg.description" />
          <v-card-actions >
            <v-spacer ></v-spacer>
            <v-btn small  >Preview and edit</v-btn>
          </v-card-actions>
        </v-card>
        <!-- <pre v-text="notification" class="caption pa-2 grey lighten-4" /> -->
      </v-col>
    </v-row>
  </v-card-text>
  <!-- <v-btn-toggle
    tile group mandatory
    v-model="notification" color="deep-purple accent-3 ma-3"  >
    <v-btn small text
      v-for='notification in notifications'
      :key='notification.id'
      :value='notification'
      v-text='notification.title'
      @click='notification=notification' />
  </v-btn-toggle> -->
  <!-- <pre v-text="notification" class="caption pa-2 grey lighten-4" /> -->
  <v-card-text>
    <notification-view
      v-if='notification'
      :slug='notification.slug' />
  </v-card-text>
</v-card>
</template>
<script>
import NotificationView from '@/components/ui/notifications/NotificationView.vue'
import NotificationMixin from '@/mixins/notifications.js'

export default {
  name: 'Notifications',
  mixins: [NotificationMixin],
  components: {NotificationView},
  data () {
    return {
      activeBtn: 0,
      notification: null
    }
  },
  watch: {
    detailview: {
      immediate: true,
      handler () {
        if (this.detailview) {
          let pg = this.notifications.find((note) => {
            return note.slug === this.detailview
          })
          if (pg) { this.notification = pg }
        }
      }
    }
  },
  methods: {
    isSelected (msg) {
      if (this.notification && this.notification.slug === msg.slug) { return "info lighten-4" }
      return null
    }
  },
  computed: {
    detailview () {
      return this.getObjectPath(this.$route, 'params.detail')
    }
  }
}
</script>
